import React from "react";
import { connect } from "react-redux";
import { PDPADetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Displays, Forms, Modals } from "components";

class PDPADetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    scrollToTopPageFN();
    if (this.props.router.params.id !== "create") {
      this.fetchData();
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  fetchData = async () => {
    let res = await portalService.GET_PDPA_DETAIL(this.props.router.params.id);
    if (res && res.status === 200) {
      this.setState({
        initialValues: res.data,
        isLoading: false,
      });
    }
  };

  // FLOW DELETE
  // =============================
  // =============================
  handleDelete = () => {
    this.setState({
      renderModal: (
        <Displays.CofirmBox
          label="คุณต้องการลบใช่หรือไม่ ?"
          labelBtn1="Confirm"
          labelBtn2="Cancel"
          onAction1={this.deleteAction}
          onAction2={this.handleCloseModal}
        />
      ),
    });
  };
  deleteAction = async () => {
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.DELETE_PDPA_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      toast.success("ลบสำเร็จ");
      this.handleNextStep();
    } else {
      toast.error("ลบไม่สำรเร็จ");
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  // FLOW SUBMIT
  // =============================
  // =============================
  handleSubmit = async (values) => {
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
    };

    let res =
      this.props.router.params.id === "create"
        ? await portalService.POST_PDPA_DETAIL(params)
        : await portalService.PUT_PDPA_UPDATE(
            this.props.router.params.id,
            params
          );
    if (res && res.status === 200) {
      toast.success("อัพเดตสำเร็จ");
      this.handleNextStep();
    } else {
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  handleNextStep = () => {
    this.props.router.navigate(ROUTE_PATH.PDPA);
  };

  // DUPLICATE PDPA
  // ===================================
  // ===================================
  handleDuplicate = async () => {
    this.setState({ isBgLoading: true });
    let res = await portalService.GET_PDPA_LIST(`?pagination=false`);
    if (res && res.status === 200) {
      const optionsTemp = res.data.docs.map((e) => ({
        label: e.pdpa_code,
        value: e._id,
      }));
      this.setState({
        pdpaData: res.data.docs,
        renderModal: (
          <Forms.PDPADuplicateForm
            options={optionsTemp}
            onCancel={this.handleCloseModal}
            onSubmit={this.handleSelectDuplicate}
          />
        ),
        isBgLoading: false,
      });
    } else {
      this.setState({ isBgLoading: false });
    }
  };
  handleSelectDuplicate = (values) => {
    const { pdpaData } = this.state;
    const findData = pdpaData.find(
      (e) => String(e._id) === String(values.pdpa.value)
    );
    if (!findData) {
      this.setState({
        renderModal: false,
      });
      toast.error("ไม่พบข้อมูลของท่าน");
    } else {
      let params = {
        ...findData,
      };
      delete params._id;
      delete params.created_at;
      delete params.updated_at;
      delete params.pdpa_code;
      delete params.is_active;
      this.setState({
        initialValues: params,
        renderModal: false,
      });
    }
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, initialValues, isBgLoading, renderModal } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "business_unit");
    return (
      <PDPADetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading theme_standard_loading />
          </div>
        ) : (
          <Forms.PDPAForm
            id={router.params.id}
            initialValues={initialValues}
            permission={permission}
            onCancel={this.handleCancel}
            onSubmit={this.handleSubmit}
            onDelete={this.handleDelete}
            onDuplicate={this.handleDuplicate}
          />
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </PDPADetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PDPADetailContainer));
